import { render, staticRenderFns } from "./TasksWidget.vue?vue&type=template&id=75b52179&"
import script from "./TasksWidget.vue?vue&type=script&lang=ts&"
export * from "./TasksWidget.vue?vue&type=script&lang=ts&"
import style0 from "./TasksWidget.vue?vue&type=style&index=0&id=75b52179&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports